// extracted by mini-css-extract-plugin
export default {"container":"YouTube_container__qt7zh","title":"YouTube_title__j2RTz","videoWrapper":"YouTube_videoWrapper__Pl4ej","video":"YouTube_video__nXIlZ","error":"YouTube_error__XeNjy"};